import { useSuspenseQuery } from '@tanstack/react-query';

import { getConsentFile } from '../api';

export const useGetConsentFile = (params) => {
  const {
    data: { data },
    isSuccess,
  } = useSuspenseQuery({
    queryKey: ['getConsentFile', params.confirmFileCode],
    queryFn: () => {
      return getConsentFile(params);
    },
  });

  return { data, isSuccess };
};
